import { useEffect } from 'react';
// contexts
import { ProtectRoute } from 'context';
import { useRouter } from 'next/router';
// components
import { Breadcrumbs } from '@components/breadcrumbs';
import Layout from '@components/Layout';
import LayoutWrapper from '@components/LayoutWrapper';
import { Table } from './Table';
import { Dropzone } from './Dropzone';
// utils && hooks
import { useUser } from 'utils/hooks';
// styles
import styles from './DisablePointsOfSale.module.css';

const DisablePointsOfSale = () => {
    const { user } = useUser({});
    const { push } = useRouter();
    const EX4611 = user?.EX4611;

    useEffect(() => {
        if (!EX4611) {
            push('/');
        }
    }, [EX4611]);

    return (
        <Layout>
            <Breadcrumbs>
                <Breadcrumbs.Label active>Deshabilitar puntos de venta</Breadcrumbs.Label>
            </Breadcrumbs>
            <LayoutWrapper>
                <div className={styles['container']}>
                    <Dropzone />
                    <Table />
                </div>
            </LayoutWrapper>
        </Layout>
    );
};

export default ProtectRoute(DisablePointsOfSale);
